'use client';

import FormContext from '@nrdy-marketing-engine/form-context/src/form-context';
import { FormProps } from '../@types/form-props';
import Form from './form';

interface FormWithContextProps extends FormProps {
  leadForm: Record<string, any>;
}

const FormWithContext = ({ leadForm, ...formProps }: FormWithContextProps) => {
  return (
    <FormContext.Provider value={{ ...leadForm, leadFormName: leadForm.slug }}>
      <Form {...formProps} />
    </FormContext.Provider>
  );
};

export default FormWithContext;
